// https://vuex.vuejs.org/en/getters.html

export default {
    events(state) {
      return state.events;
    },
  };
  